/* 主题化 */
/* 国际化 */
import {urlDomainDeal} from "@src/utils/common";
import lang from './lang';

let _locale = lang.lang;
export let locale = _locale;

export function i18n(nls, lan = _locale) {
  nls = {...(nls.default || {}), ...nls};
  if (!nls.locales || !nls.locales[lan]) {
    return nls;
  }
  if (typeof nls.locales[lan] == 'function') {
    return nls.locales[lan]();
  }
  if (nls.locales[lan]) {
    return {...(nls.locales[lan].default || {}), ...nls.locales[lan]};
  }
  return {...(nls.default || {}), ...nls};
}

export function refresh(lang) {
  let href = window.location.href;
  if (href.search('lang=') > 0) {
    if (lang === 'zh') {
      href = href.replace('lang=en', 'lang=zh');
    } else {
      href = href.replace('lang=zh', 'lang=en');
    }
  } else {
    if (href.search('\\?') > 0) {
      href += '&lang=' + lang;
    } else {
      href += '?lang=' + lang;
    }
  }
  window.location.href = urlDomainDeal(href);
  window.location.reload(true);
}
